import { logAmplitudeEvent } from '@eventbrite/site-analytics';

export const triggerAmplitudeEvent = (eventName) => (dispatch, getState) => {
    try {
        const {
            event: { id: eventId },
        } = getState();

        logAmplitudeEvent(eventName, {
            event_id: eventId,
        });
    } catch (e) {}
};
